import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode'; // <-- IMPORTAR
import FormStepper from '../components/FormStepper';
import Navbar from '../components/NavBar';

function FormPage() {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);

  // Este efeito executa quando a página é carregada
  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      try {
        // Decodifica o token para pegar as informações do usuário
        const decodedToken = jwtDecode(token);
        setUser(decodedToken);
      } catch (error) {
        console.error("Token inválido:", error);
        handleLogout(); // Se o token for inválido, desloga o usuário
      }
    } else {
      // Se não houver token, redireciona para a página de login
      navigate('/');
    }
  }, [navigate]);

  // Função para fazer logout
  const handleLogout = () => {
    localStorage.removeItem('token'); // Remove o token
    navigate('/'); // Redireciona para o login
  };

  return (
    <div className="min-h-screen bg-gray-100 text-gray-900 flex flex-col items-center">
      {/* Renderiza o Navbar, passando o nome do usuário e a função de logout */}
      <Navbar 
        nomeUsuario={user?.usuario} 
        onLogout={handleLogout} 
      />
      <div className="w-full p-4 flex justify-center">
        <FormStepper />
      </div>
    </div>
  );
}

export default FormPage;